module.exports = __webpack_public_path__ + "static/media/logo.6df8b758.png";